import { useState } from 'react';

const faqs = [
  {
    q: 'What does a functional medicine doctor do differently than a regular doctor?',
    a: 'A functional medicine doctor like Dr. Leder investigates the root causes of illness — not just symptoms. She uses extended visit times, advanced functional testing, and personalized protocols combining nutrition, hormones, IV therapies, and lifestyle medicine. Standard doctors typically prescribe for symptoms; Dr. Leder finds and fixes the underlying cause.'
  },
  {
    q: 'Who is the best functional medicine doctor near Hackensack, NJ?',
    a: 'Dr. Robin Ellen Leder, MD at A Better Alternative Medical Center in Hackensack is Bergen County\'s most experienced functional medicine physician with 40+ years in practice. She offers advanced root-cause care, IV chelation, hormone therapy, and orthomolecular psychiatry — delivering outcomes most conventional doctors cannot.'
  },
  {
    q: 'How much does functional medicine treatment cost in New Jersey?',
    a: 'Costs vary by program and complexity. Dr. Leder offers a free 10-minute phone consultation to discuss your needs and explain pricing before you commit. Call (201) 525-1155 on Tuesday, Thursday, or Saturday. Many patients find the investment significantly less than years of unresolved symptoms and ineffective conventional treatments.'
  },
  {
    q: 'How long does it take to see results with functional medicine?',
    a: 'Many patients report meaningful improvements within 4–8 weeks of starting a personalized protocol. Chronic or complex conditions may take 3–6 months for full resolution. Dr. Leder monitors progress closely and adjusts protocols at every follow-up visit to ensure you\'re making steady, measurable improvement toward your health goals.'
  },
  {
    q: 'What should I expect at my first visit with Dr. Leder?',
    a: 'Your first visit is extended and thorough — a comprehensive health history review, physical examination, and in-depth lifestyle discussion. Dr. Leder listens to everything. Unlike a typical 7-minute appointment, you\'ll spend real time together. Most patients leave the initial visit with clarity, direction, and a preliminary plan for the first time in years.'
  },
  {
    q: 'Does Dr. Leder offer natural alternatives to antidepressants and anxiety medications?',
    a: 'Yes. Dr. Leder\'s background in orthomolecular psychiatry allows her to identify biochemical imbalances driving anxiety, depression, and mood disorders. Through targeted supplementation, hormonal balancing, and functional nutrition, many patients significantly reduce or eliminate psychiatric medications under her supervised, evidence-based protocols.'
  },
  {
    q: 'What is chelation therapy and who needs it in New Jersey?',
    a: 'Chelation therapy uses IV EDTA to safely remove heavy metals like lead, mercury, and arsenic. It also reduces arterial plaque. Dr. Leder offers chelation in Hackensack, NJ for patients with heavy metal toxicity, cardiovascular concerns, neurological symptoms, or chronic fatigue that hasn\'t responded to other treatments.'
  },
  {
    q: 'Does Dr. Leder accept new patients in Bergen County, NJ?',
    a: 'Yes, Dr. Leder is currently accepting new patients at her Hackensack, NJ practice. The first step is a complimentary 10-minute phone consultation. Call (201) 525-1155 on Tue/Thu/Sat or (551) 298-8799 on Sun/Mon/Wed/Fri. Patients travel from across Bergen County, Hoboken, Jersey City, and New York City.'
  }
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="py-20 px-6 lg:px-12 bg-teal-50">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <p className="text-teal-600 text-sm font-semibold tracking-widest uppercase mb-3">Frequently Asked Questions</p>
          <h2 className="font-heading text-4xl font-bold text-teal-950 mb-4">
            Common Questions About Functional Medicine in Hackensack, NJ
          </h2>
          <p className="text-gray-600">
            Answers to the questions patients across Bergen County most frequently ask Dr. Leder's office.
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <div key={i} className="bg-white border border-teal-100 rounded-lg overflow-hidden">
              <button
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                className="w-full flex items-center justify-between px-6 py-5 text-left cursor-pointer hover:bg-teal-50 transition-colors"
              >
                <h4 className="font-semibold text-teal-900 text-sm pr-4 leading-relaxed">{faq.q}</h4>
                <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                  <i className={`${openIndex === i ? 'ri-subtract-line' : 'ri-add-line'} text-teal-600 text-xl`}></i>
                </div>
              </button>
              {openIndex === i && (
                <div className="px-6 pb-5 border-t border-teal-50">
                  <p className="text-gray-600 text-sm leading-relaxed pt-4">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-10 bg-teal-900 text-white rounded-lg p-6 text-center">
          <p className="font-heading text-lg font-semibold mb-2">Still have questions?</p>
          <p className="text-teal-300 text-sm mb-4">Call Dr. Leder's office for a free 10-minute phone consultation. No obligation.</p>
          <a href="tel:2015251155" className="inline-flex items-center gap-2 bg-white text-teal-900 px-6 py-3 rounded-md text-sm font-semibold hover:bg-teal-50 transition-colors cursor-pointer whitespace-nowrap">
            <div className="w-4 h-4 flex items-center justify-center"><i className="ri-phone-fill text-teal-700 text-base"></i></div>
            Call (201) 525-1155
          </a>
        </div>
      </div>
    </section>
  );
}
